/**
 * @generated SignedSource<<7abff2f8bd086dfba669bca60d5d69ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type processDefinitionQuery$variables = {
  id: string;
};
export type processDefinitionQuery$data = {
  readonly getProcessDefinition: {
    readonly " $fragmentSpreads": FragmentRefs<"processDefinitionQueryFragment">;
  } | null | undefined;
};
export type processDefinitionQuery = {
  response: processDefinitionQuery$data;
  variables: processDefinitionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinition",
        "kind": "LinkedField",
        "name": "getProcessDefinition",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "processDefinitionQueryFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinition",
        "kind": "LinkedField",
        "name": "getProcessDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionXml",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "siteUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dirtyFlag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionHash",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "59f4266b4e54ef3a8dc3f72c7041fa60",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQuery",
    "operationKind": "query",
    "text": "query processDefinitionQuery(\n  $id: ID!\n) {\n  getProcessDefinition(id: $id) {\n    ...processDefinitionQueryFragment\n    id\n  }\n}\n\nfragment processDefinitionQueryFragment on ProcessDefinition {\n  definitionKey\n  definitionId\n  definitionName\n  definitionVersion\n  definitionXml\n  id\n  siteUrl\n  status\n  dirtyFlag\n  definitionHash\n}\n"
  }
};
})();

(node as any).hash = "5429dbfcf3c78a061f766f6c45ca2863";

export default node;
